import React from 'react'
import Stack from '@mui/material/Stack'
import Box from '@mui/material/Box'
import TextField from '@mui/material/TextField'
import Stack from '@mui/material/Stack'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Alert from '@mui/material/Alert'

import { compileSchema } from '~/lib/json-schema'
import Form from '~/client/components/Form'
import ErrorMessage from '~/client/components/ErrorMessage'
import FormButtonRow from '~/client/components/FormButtonRow'
import JSONSchemaFormInput from '~/client/components/JSONSchemaFormInput'
import JsonSchemaBuilder from '~/client/components/JsonSchemaBuilder'

export default function DocumentTypeCreateForm({
  value,
  onChange,
  onSubmit,
  submitting,
  error,
}){

  // const [onSchemaTab, showBuilderTab, showSchemaTab, toggleSchemaTab] = useToggle()
  const [tab, setTab] = React.useState('builder')

  // const schemaValid = isValidSchema(value?.schema)
  const [schemaValid, schema, compiledSchema, schemaError] = React.useMemo(
    () => {
      try{
        const schema = JSON.parse(value?.schema)
        return [ true, schema, compileSchema(schema) ]
      }catch(error){
        return [ false, null, null, error ]
      }
    },
    [value?.schema]
  )
  console.log('VALID SCHEMA?', {
    schema: value?.schema,
    schemaValid,
    schemaError,
  })

  const patch = changes =>
    onChange({...value, ...changes})
  const setSchema = schema =>
    patch({ schema: JSON.stringify(schema, null, 2) })

  const change = prop =>
    event => patch({ [prop]: event.target.value })

  return <Form {...{
    onSubmit,
  }}>
    <ErrorMessage error={error}/>

    <Stack spacing={2}>
      <TextField
        label="name"
        inputProps={{name: 'name'}}
        value={value.name}
        onChange={change('name')}
      />
      <TextField
        label="description"
        inputProps={{name: 'description'}}
        multiline
        value={value.description}
        onChange={change('description')}
      />
      <Box>
        <Tabs
          variant="fullWidth"
          value={tab}
          onChange={(e,v) => setTab(v)}
          sx={{mb:1}}
        >
          <Tab label="BUILDER" value="builder" />
          <Tab label="SCHEMA" value="schema" />
          <Tab label="PREVIEW" value="preview" disabled={!schemaValid}/>
        </Tabs>
        {tab === 'schema'
          ? <Box>
            <Alert severity={schemaValid ? 'success' : 'warning'} sx={{my: 1}}>
              Schema {schemaValid ? 'valid :D' : 'invalid!'}
            </Alert>
            <ErrorMessage error={schemaError} sx={{mb:2}}/>
            <TextField
              label="schema"
              inputProps={{name: 'schema'}}
              multiline
              placeholder={PLACEHOLDER_SCHEMA}
              fullWidth
              value={value.schema}
              onChange={change('schema')}
            />
          </Box>
          : null
        }
        {tab === 'builder'
          ? <JsonSchemaBuilder
            value={schema}
            onChange={setSchema}
          />
          : null
        }
        {tab === 'preview'
          ? <SchemaFormPreview schema={schema} />
          : null
        }

      </Box>
      <FormButtonRow {...{
        cancelTo: '/documents/types',

      }}/>
    </Stack>
  </Form>
}



function SchemaFormPreview({schema}){
  return <Box>
    <JSONSchemaFormInput {...{
      schema,
      onChange(){ },
    }}/>
  </Box>
}


const PLACEHOLDER_SCHEMA = `
{
  "title": "Date and time widgets",
  "type": "object",
  "properties": {
    "native": {
      "title": "Native",
      "description": "May not work on some browsers, notably Firefox Desktop and IE.",
      "type": "object",
      "properties": {
        "datetime": {
          "type": "string",
          "format": "date-time"
        },
        "date": {
          "type": "string",
          "format": "date"
        }
      }
    },
    "alternative": {
      "title": "Alternative",
      "description": "These work on most platforms.",
      "type": "object",
      "properties": {
        "alt-datetime": {
          "type": "string",
          "format": "date-time"
        },
        "alt-date": {
          "type": "string",
          "format": "date"
        }
      }
    }
  }
}
`.trim()
